/**
 * Terms and Conditions agreement logic for Cart page and Mini-cart drawer
 */
(function initTermsAndConditions() {
  function syncCheckoutState() {
    document.querySelectorAll('#agree-terms, #agree-terms-mini').forEach(function(checkbox) {
      var form = checkbox.closest('form');
      if (!form) return;
      var checkoutBtn = form.querySelector('[name="checkout"]');
      if (!checkoutBtn) return;

      if (checkbox.checked) {
        checkoutBtn.style.opacity = '1';
        checkoutBtn.style.cursor = 'pointer';
        checkoutBtn.classList.remove('is-disabled');
      } else {
        checkoutBtn.style.opacity = '0.5';
        checkoutBtn.style.cursor = 'not-allowed';
        checkoutBtn.classList.add('is-disabled');
      }
    });
  }

  // Intercept click on any checkout button globally (Capture Phase)
  document.addEventListener('click', function(e) {
    var checkoutBtn = e.target.closest('[name="checkout"]');
    if (!checkoutBtn) return;

    var form = checkoutBtn.closest('form');
    if (!form) return;

    var checkbox = form.querySelector('#agree-terms, #agree-terms-mini');
    if (!checkbox && (form.id === 'mini-cart' || checkoutBtn.closest('.mini-cart'))) {
      checkbox = document.getElementById('agree-terms-mini');
    }
    if (!checkbox && (form.classList.contains('cart-recap') || checkoutBtn.closest('.cart-recap'))) {
      checkbox = document.getElementById('agree-terms');
    }
    if (!checkbox) return;

    if (!checkbox.checked) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var wrapper = form.querySelector('#cart-terms-wrapper, #mini-cart-terms-wrapper, .cart-terms') ||
                    document.getElementById('mini-cart-terms-wrapper') ||
                    document.getElementById('cart-terms-wrapper');
      if (wrapper) wrapper.classList.add('is-invalid');

      var errorEl = form.querySelector('#agree-terms-error, #agree-terms-mini-error, .cart-terms__error') ||
                    document.getElementById('agree-terms-mini-error') ||
                    document.getElementById('agree-terms-error');
      if (errorEl) errorEl.style.display = 'block';

      checkbox.focus();
      return false;
    } else {
      // Checkbox is checked!
      // In mini-cart drawer: save attribute via Cart API and redirect to checkout
      if (form.id === 'mini-cart' || checkoutBtn.closest('.mini-cart')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        checkoutBtn.style.opacity = '0.7';
        checkoutBtn.style.pointerEvents = 'none';

        var root = (window.routes && (window.routes.rootUrlWithoutSlash !== undefined ? window.routes.rootUrlWithoutSlash : window.routes.rootUrl)) || '';
        if (root === '/') root = '';
        if (root.endsWith('/')) root = root.slice(0, -1);
        var checkoutUrl = root + '/checkout';
        var updateUrl = root + '/cart/update.js';

        var attrName = checkbox.name || 'attributes[Terms and Conditions]';
        var attrVal = checkbox.value || 'Yes';
        var cleanKey = attrName.replace(/^attributes\[(.*)\]$/, '$1');

        var updatePayload = { attributes: {} };
        updatePayload.attributes[cleanKey] = attrVal;

        fetch(updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(updatePayload)
        }).then(function() {
          window.location.href = checkoutUrl;
        }).catch(function() {
          window.location.href = checkoutUrl;
        });

        return false;
      }
      // In main cart page: allow native form submission to proceed
    }
  }, true);

  // Handle checkbox change globally
  document.addEventListener('change', function(e) {
    var checkbox = e.target.closest('#agree-terms, #agree-terms-mini');
    if (!checkbox) return;

    var form = checkbox.closest('form');
    var wrapper = (form && form.querySelector('#cart-terms-wrapper, #mini-cart-terms-wrapper, .cart-terms')) ||
                  document.getElementById('mini-cart-terms-wrapper') ||
                  document.getElementById('cart-terms-wrapper');
    var errorEl = (form && form.querySelector('#agree-terms-error, #agree-terms-mini-error, .cart-terms__error')) ||
                  document.getElementById('agree-terms-mini-error') ||
                  document.getElementById('agree-terms-error');
    var checkoutBtn = form ? form.querySelector('[name="checkout"]') : null;

    if (checkbox.checked) {
      if (wrapper) wrapper.classList.remove('is-invalid');
      if (errorEl) errorEl.style.display = 'none';
      if (checkoutBtn) {
        checkoutBtn.style.opacity = '1';
        checkoutBtn.style.cursor = 'pointer';
        checkoutBtn.classList.remove('is-disabled');
      }
    } else {
      if (wrapper) wrapper.classList.add('is-invalid');
      if (errorEl) errorEl.style.display = 'block';
      if (checkoutBtn) {
        checkoutBtn.style.opacity = '0.5';
        checkoutBtn.style.cursor = 'not-allowed';
        checkoutBtn.classList.add('is-disabled');
      }
    }
  }, true);

  // Intercept form submit globally (e.g. Enter key)
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('form');
    if (!form) return;

    var checkbox = form.querySelector('#agree-terms, #agree-terms-mini');
    if (!checkbox) return;

    if (!checkbox.checked) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var wrapper = form.querySelector('#cart-terms-wrapper, #mini-cart-terms-wrapper, .cart-terms');
      if (wrapper) wrapper.classList.add('is-invalid');

      var errorEl = form.querySelector('#agree-terms-error, #agree-terms-mini-error, .cart-terms__error');
      if (errorEl) errorEl.style.display = 'block';

      checkbox.focus();
      return false;
    }
  }, true);

  // Observe DOM changes (when mini-cart opens or re-renders via AJAX)
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function() {
      syncCheckoutState();
    });
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        observer.observe(document.body, { childList: true, subtree: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCheckoutState);
  } else {
    syncCheckoutState();
  }
})();
